import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    entityType: Yup.string(),
    syncStatus: Yup.string(),
});
